import PhotoAttendance from "./Photo/PhotoAttendance";
import QrAttendance from "./QR/QrAttendance";

const Attendance = () => {
  const user: any = JSON.parse(sessionStorage.getItem("user") || "null");
  const role: any = sessionStorage.getItem("userRole") || "";

  const attendanceType =
    role === "superadmin" ? user.attendanceType : user.companyAttendanceType;

  return (
    <>
      {attendanceType === "SELFIE" ? (
        <PhotoAttendance />
      ) : attendanceType === "QR" ? (
        <QrAttendance />
      ) : null}
    </>
  );
};

export default Attendance;
